import { render, staticRenderFns } from "./ParametrosPesquisa.vue?vue&type=template&id=42049f84&scoped=true&"
import script from "./ParametrosPesquisa.vue?vue&type=script&lang=js&"
export * from "./ParametrosPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosPesquisa.vue?vue&type=style&index=0&id=42049f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42049f84",
  null
  
)

export default component.exports